<template>
  <div class="pie-chart-container">
    <i class="hover-hint" v-if="!this.$store.getters.isMobile"
      >Hover over charts for population %s:</i
    >
    <v-card elevation="1" class="chart-holder" outlined tile>
      <!-- <v-card-title class="chart-title"> Citizen Voting Age Population </v-card-title>
    <v-card-title class="chart-title"> Total Population </v-card-title> -->
      <div class="chart-container">
        <div
          class="pie-chart-div"
          id="tot-chart-container"
          :ref="this.legBody + 'totChartContainer'"
        >
          <span class="chart-title"> Total Population </span>
          <i
            id="totPercent"
            v-if="!this.$store.getters.isMobile"
            class="chart-pct"
            >Hover over legend to highlight chart</i
          >
        </div>
        <div
          class="pie-chart-div"
          id="vap-chart-container"
          :ref="this.legBody + 'vapChartContainer'"
        >
          <span class="chart-title"> Voting Age Pop. (VAP) </span>
          <i
            id="vapPercent"
            v-if="!this.$store.getters.isMobile"
            class="chart-pct"
            >Hover over legend to highlight chart</i
          >
        </div>
      </div>
      <div class="legend">
        <div class="column-1">
          <span
            @mouseover="mouseOver(i)"
            @mouseleave="mouseLeave(i)"
            v-for="(l, i) in legendColumnOne"
            :key="i"
            class="legend-item"
          >
            <span
              class="swatch"
              :style="{
                backgroundColor: l.color,
                border: `0px solid ${l.color}`,
              }"
            ></span>
            {{ l.name }}
            <div class="print-only">
              VAP: {{ vapArray[i].pct }}% Total: {{ totArray[i].pct }}%
            </div>
          </span>
        </div>
        <div class="column-2">
          <span
            @mouseover="mouseOver(i + 4)"
            @mouseleave="mouseLeave(i + 4)"
            v-for="(l, i) in legendColumnTwo"
            :key="i"
            class="legend-item"
          >
            <span
              class="swatch"
              :style="{
                backgroundColor: l.color,
                border: `0px solid ${l.color}`,
              }"
            ></span>
            {{ l.name }}
            <div class="print-only">
              VAP: {{ vapArray[i].pct }}% Total: {{ totArray[i].pct }}%
            </div>
          </span>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import * as d3 from "d3";
import { Config, Enums } from "../../data/Config/Config";
//import DemoArrayManager from "../../data/DemographicData/DemoArrayManager";

export default {
  name: "PieChart",
  props: ["geoid", "legBody"],
  components: {
    
  },
  mounted: function () {
    //  let elements = document.getElementsByClassName("tooltip");
    //   while (elements.length > 3) {
    //     elements[0].parentNode.removeChild(elements[0]);
    //   }
    this.demoArrayManager = Config.dataArrayManager;
    this.buildPie("tot");
    // this.buildPie("cvap");
    this.buildPie("vap");
},
  methods: {
    calculatePercents: function () {
      let totPop = 0;
      this.districtArray.forEach((element) => {
        totPop += +element.value;
      });
      this.districtArray.forEach((element) => {
        element["pct"] = ((+element.value / totPop) * 100).toFixed(1);
      });
    },
    buildPie: function (popType) {
      this.$refs[`${this.legBody}${popType}ChartContainer`].innerHTML = `
      <span class='chart-title'> ${
        popType === "tot" ? "Total Population" : "Voting Age Pop. (VAP)"
      } </span>

      <i id="${popType}Percent" class="chart-pct">Hover over legend to highlight chart</i>
      `;
      //if(!this.popType) this.popType = "tot";
      this.districtArray = [
        //Colors from CUR Visualizing a Changing Region 2010
        {
          name: "Hispanic",
          value: this.postgresDataObj[`hisp${popType}20`],
          color: "#31A353", //#914200
        },
        {
          name: "White non-Hispanic",
          value: this.postgresDataObj[`whitenh${popType}20`],
          color: "#6CAFD6", //#005757
        },
        {
          name: "Asian",
          value: this.postgresDataObj[`asiannh${popType}20`],
          color: "#C10F83", //#E34848
        },
        {
          name: "Black",
          value: this.postgresDataObj[`blacknh${popType}20`],
          color: "#E6560E", //#E38E48
        },
        {
          name: "Amer. Indian/AK Native",
          value: this.postgresDataObj[`aiannh${popType}20`],
          color: "#756BB1", //#b3de69
        },
        {
          name: "Nat. Haw./Other PI",
          value: this.postgresDataObj[`nathawnh${popType}20`],
          color: "#969696", //#fdb462
        },
        {
          name: "Other race/multiple race",
          value: this.postgresDataObj[`othernh${popType}20`],
          color: "#fdb462", //#007400
        },
      ];

      this[`${popType}Array`] = this.districtArray;

      this.calculatePercents();

      const width = 150;
      const height = 100;

      const color = d3
        .scaleOrdinal()
        .domain(this.districtArray.map((d) => d.value))
        .range(
          d3
            .quantize(
              (t) => d3.interpolateSpectral(t * 0.8 + 0.1),
              this.districtArray.length
            )
            .reverse()
        );

      const arcs = d3
        .pie()
        .value(function (d) {
          return d.value;
        })
        .sort(null)(this.districtArray);

      const self = this;
      let tooltip;
      if (popType === "tot") {
        this.totTooltip =
          this.totTooltip ||
          d3
            .select("body")
            .append("div")
            .style("position", "absolute")
            .classed("tooltip", true)
            .style("z-index", "10")
            .style("visibility", "hidden")
            .style("background", "#fffd");
            tooltip = this.totTooltip;
      }

      if (popType === "vap") {
        this.vapTooltip =
          this.vapTooltip ||
          d3
            .select("body")
            .append("div")
            .style("position", "absolute")
            .classed("tooltip", true)
            .style("z-index", "10")
            .style("visibility", "hidden")
            .style("background", "#fffd");
             tooltip = this.vapTooltip;
      }

      const svg = d3
        .select(self.$refs[`${this.legBody}${popType}ChartContainer`])
        .append("svg")
        .attr("viewBox", [-width / 2, -height / 2, width, height]);

      this[`${popType}SVG`] = svg;

      svg
        .append("g")
        .selectAll("path")
        .data(arcs)
        .join("path")
        .attr("fill", (d) => d.data.color)
        .on("mouseenter", function (d, i) {
          tooltip.text(
            `${i.data.name}: \r\n ${i.data.pct}% ${
              popType === "tot" ? "(Total Pop.)" : "(VAP)"
            }`
          );
          return tooltip.style("visibility", "visible");
        })
        .on("mousemove", function (e) {
          return tooltip
            .style("top", e.clientY - 10 + "px")
            .style("left", e.clientX + 10 + "px")
            .style("visibility", "visible");
        })
        .on("mouseleave", function (d, i) {
          return tooltip.style("visibility", "hidden");
        })
        .attr(
          "d",
          d3
            .arc()
            .innerRadius(25)
            .outerRadius(width / 3 - 1)
        );
    },
    mouseOver: function (i) {
      this["totSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          if (j === i) {
            document.getElementById(
              `totPercent`
            ).innerText = `${d.data.name}: ${d.data.pct}%`;
          }
          return j === i;
        })
        .classed("outline-show", true);
      //.append('h1').text(function (d) { d.data.pct});

      this["vapSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          if (j === i) {
            document.getElementById(
              `vapPercent`
            ).innerText = `${d.data.name}: ${d.data.pct}%`;
          }
          return j === i;
        })
        .classed("outline-show", true);
    },
    mouseLeave: function (i) {
      document.getElementById(`vapPercent`).innerText =
        "Hover over legend to highlight chart";

      document.getElementById(`totPercent`).innerText =
        "Hover over legend to highlight chart";
      this["totSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          return j === i;
        })
        .classed("outline-show", false);

      this["vapSVG"]
        .selectAll("g")
        .selectAll("path")
        .filter(function (d, j) {
          return j === i;
        })
        .classed("outline-show", false);
    },
  },
  watch: {
    geoid: function (val) {
      this.buildPie("tot");
      this.buildPie("vap");
    },
  },
  computed: {
    postgresDataObj: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },

    activeDistrictType: function () {
      return this.$store.getters.getDistrictType;
    },

    legendColumnOne: function () {
      return this.districtArray.slice(
        0,
        Math.round(this.districtArray.length / 2)
      );
    },

    legendColumnTwo: function () {
      return this.districtArray.slice(
        Math.round(this.districtArray.length / 2),
        this.districtArray.length
      );
    },
  },
  data: function () {
    return {
      Enums: Enums,
      districtArray: [],
      hover: {},
      totArray: [],
      vapArray: [],
      totSVG: null,
      vapSVG: null,
      totPercent: 0,
      vapPercent: 0,
      totTooltip: null,
    vapTooltip: null,
    };
  },
};
</script>
<style scoped>
.pie-chart-container {
  width: 100%;
}

.pie-chart-div {
  width: 50%;
  padding: 5px;
  display: inline-block;
}

div .legend span {
  display: block;

  margin-right: 5px;
  margin-bottom: -4px;
  /* border: 1px solid darkgrey; */
  /* border: 1px solid rgb(253, 253, 253); */
  opacity: 0.9;
}

.chart-holder {
  padding: 0 5px;
  margin: 5px 0px;
  background-color: #fff7 !important;
}
.legend {
  font-size: 0.9em;
  display: inline-block;
  width: 100%;
  padding: 1%;
  border-top: 1px solid #80808030;
}

.column-1,
.column-2 {
  width: 48%;
  display: inline-block;
  /* font-size: .9em; */
  position: initial;
}

.column-1 span,
.column-2 span {
  cursor: default !important;
}

.column-2 {
  position: absolute;
}
.swatch {
  width: 15px;
  height: 15px;
  display: inline-block !important;
}

#vap-chart-container {
  border-left: 1px solid #d3d3d352;
}

#tot-chart-container {
  border-right: 1px solid #d3d3d352;
}
</style>
<style>
.tooltip {
  padding: 10px;
  border-radius: 4px;
  font-family: "Roboto", Tahoma, sans-serif;
}
.chart-title {
  font-weight: bold;
  text-align: center;
  width: 100%;
  display: inline-block;
}

.hover-hint {
  color: gray;
}

.chart-pct {
  color: gray;
  /* max-height: 10px; */
  font-size: 0.9em;
  height: 38px;
  display: block;
  line-height: 1.4;
}

.outline-show {
  stroke: #000000;
  stroke-width: 3px;
  stroke-linejoin: round;
}

.legend-item:hover {
  background-color: lightgray;
  border-radius: 0;
}

.print-only,
#print-container .hover-hint,
#print-container .chart-pct {
  display: none;
}

#print-container .print-only {
  display: block;
  border-bottom: 1px solid lightgrey;
  padding: 10px 0px;
  margin-bottom: 10px;
}
</style>